const audiences = [
  { value: 'public', name: 'Public' },
  { value: 'members', name: 'Members' },
  { value: 'internal', name: 'Internal' },
];
export default audiences;
